module.exports = __webpack_public_path__ + "static/media/evaluate_contribution_ja.d65bdb5c.png";